import * as Flux from 'dg-web-shared/lib/Flux.tsx';
import { isUndefined } from 'dg-web-shared/lib/MaybeV2.ts';
import { Translation, Translations } from '../../../common/i18n/Text.ts';
import { Permit } from '../../state/ResultState.ts';
import { ClearancePermitsList } from '../clearances-list/ClearancePermitsList.tsx';
import {
    ClearanceListItem,
    ClearanceListItemRow,
    Toggle,
} from '../clearances-list/ClearancesListItem.tsx';
import { PermitItem } from '../permit/PermitItem.tsx';
import { OperatorTypo } from '../../../ui/OperatorTypo.ts';
import { css } from '@emotion/css';
import { ColorHex } from '../../../ui/Colors.ts';
import { useState, type JSX } from 'react';

interface PermitsListProps {
    language: string;
    permits: Permit[];
    update: Flux.Updater;
    hasClearances: boolean;
}

interface Texts {
    ClearancesWithoutPermits: Translation;
}

const texts: Translations<Texts> = {
    de: {
        ClearancesWithoutPermits: () => 'Bewilligungen ohne Freigabe',
    },
    fr: {
        ClearancesWithoutPermits: () => 'Autorisations sans approbation',
    },
    it: {
        ClearancesWithoutPermits: () => 'Autorizzazioni senza approvazione',
    },
};

export function PermitsList({
    language,
    permits,
    update,
    hasClearances,
}: PermitsListProps) {
    const [expanded, setExpanded] = useState(true);

    function renderListItems(): JSX.Element[] {
        return permits.map((permit: Permit) => {
            return (
                <PermitItem key={permit.id} permit={permit} update={update} />
            );
        });
    }

    function renderPermitsWithoutWhitelist(): JSX.Element {
        return (
            <ClearanceListItem>
                <ClearanceListItemRow onClick={() => {}}>
                    <Toggle
                        expandable={true}
                        expanded={expanded}
                        onToggle={() => {
                            setExpanded(!expanded);
                        }}
                    />
                    <div
                        className={css({
                            ...OperatorTypo.bodyC,
                            display: 'table-cell',
                            verticalAlign: 'middle',
                            paddingLeft: '8px',
                            color: ColorHex.darkblue,
                            position: 'relative',
                        })}
                    >
                        {texts[language].ClearancesWithoutPermits()}
                    </div>
                </ClearanceListItemRow>
                <ClearancePermitsList
                    permits={permits}
                    expanded={expanded}
                    update={update}
                />
            </ClearanceListItem>
        );
    }

    if (isUndefined(permits) || permits.length === 0) {
        return null;
    } else if (hasClearances) {
        return <div>{renderPermitsWithoutWhitelist()}</div>;
    } else {
        return <div>{renderListItems()}</div>;
    }
}
